const rankingData = [
  { rank: 1, title: '狂飙', type: '电视剧', hot: '9.8', tag: '爆款', change: 'up' },
  { rank: 2, title: '流浪地球2', type: '电影', hot: '9.7', tag: '科幻巨制', change: 'up' },
  { rank: 3, title: '长相思', type: '电视剧', hot: '9.6', tag: '热播中', change: 'new' },
  { rank: 4, title: '孤注一掷', type: '电影', hot: '9.5', tag: '反诈题材', change: 'up' },
  { rank: 5, title: '奔跑吧·生态篇', type: '综艺', hot: '9.3', tag: '热门综艺', change: 'down' },
  { rank: 6, title: '封神第一部', type: '电影', hot: '9.2', tag: '史诗大片', change: 'up' },
  { rank: 7, title: '王牌对王牌8', type: '综艺', hot: '9.1', tag: '经典回归', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-fire-fill"></i>实时热度
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">全网影视热播榜</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时追踪奇优影院、97影院等全网最新热门影视，热度排行每日更新
          </p>
        </div>

        <div className="bg-background-50 rounded-xl overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 ${
                i < rankingData.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-background-100/60 transition-colors cursor-pointer`}
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-foreground-900 text-sm md:text-base truncate">{item.title}</span>
                  <span className="shrink-0 px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <span className="text-xs text-foreground-500 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap shrink-0">{item.type}</span>
              <div className="hidden sm:flex items-center gap-3 shrink-0">
                <span className="text-sm font-semibold text-primary-600">{item.hot}</span>
                <span className={`w-5 h-5 flex items-center justify-center ${item.change === 'up' ? 'text-accent-600' : item.change === 'new' ? 'text-primary-600' : 'text-secondary-500'}`}>
                  {item.change === 'up' && <i className="ri-arrow-up-fill text-sm"></i>}
                  {item.change === 'new' && <i className="ri-star-fill text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-fill text-sm"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}